module.exports = __webpack_public_path__ + "img/giro.4888dc9b.svg";